var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUpdate48Line = function SvgIconUpdate48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.35 12.41-1.08 4.47A14.17 14.17 0 0 0 24 9.8c-6.47 0-12.12 4.38-13.74 10.65l3.29.85c1.23-4.77 5.52-8.1 10.44-8.1 4.11 0 7.78 2.33 9.59 5.88l-5.16-1.52-.96 3.26 7.67 2.26a2.842 2.842 0 0 0 2.26-.27c.68-.39 1.18-1.06 1.37-1.83l1.88-7.77-3.3-.8h.01ZM24 34.8c-4.11 0-7.78-2.33-9.59-5.88l5.16 1.52.96-3.26-7.67-2.26c-.76-.22-1.58-.12-2.27.27-.68.39-1.18 1.06-1.37 1.83l-1.88 7.77 3.3.8 1.08-4.47a14.17 14.17 0 0 0 12.27 7.08c6.47 0 12.12-4.38 13.74-10.65l-3.29-.85c-1.23 4.77-5.52 8.1-10.44 8.1Z",
    fill: "current"
  })));
};
export default SvgIconUpdate48Line;